module.exports={
    import: {
        search:'搜索',
        sure:'确定',
        downloadResultFile:'下载结果文件',
        importPro:'导入商品',
        downloadTemplate:'下载模板',
        table:{
        	index:'序号',
        	fileName:'文件名称',
        	totalNumber:'总记录数',
        	uploadTime:'上传时间',
        	completeTime:'完成时间',
        	result:'处理结果',
            uploadUser:'上传用户',
            operation:'操 作'
        },
        hintMsg:{
            success:'成功',
            failed:'失败',
            queryImportFail:'查询导入文件信息失败',
            uploadFailed:'导入文件处理失败，请重新导入'
        },
        upload:{
            format:'上传文件只能是Excel表格',
            success:'上传文件成功，请稍后下载结果文件并查看处理结果',
            fail:'导入商品失败',
            incorrectFormat:'文件格式不正确',
            parseFail:'文件解析失败',
            noPermission:'导入商品失败，没有权限'
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/zh/import.js